







































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import commonService from '@/services/common-services';
import formatNumber from '@/shared/filters/format-number';
import { APP_CONFIG } from '@/config/app-config';
import { Customer } from '@/models/customer';
import ProgressBar from 'vue-simple-progress';
import Credit from '@/pages/credit/Credit.vue';

@Component({
    components: {
        ProgressBar,
        'credit': Credit
    }
})
export default class ProfileRight extends Vue {
    @Prop({default: null})
    private customer!: Customer;

    @Prop({default: null})
    private submitForm!: any;

    @Watch('submitForm', { immediate: true, deep: true })
    private async watchSubmitForm() {
        if (this.submitForm) {
            if (await this.validateForm() === true) {
                await this.submitForm();
            }
        }
    }

    private tab = {
        customerInfo: 'customerInfo',
        password: 'password',
        information: 'information',
        finance: 'finance',
    };
    private selectedTab = this.tab.information;
    private provinces: any[] = [];
    private districts: any[] = [];
    private communes: any[] = [];

    private onSelectedTab(tab: any) {
        this.selectedTab = tab;
        this.$emit('tabChange', this.selectedTab);
    }

    get warehouse() {
        let tmp = this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
        return tmp ? tmp.filter(p => p.StoreType === 1) : null;
    }

    get chinaStore() {
        let tmp = this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
        return tmp ? tmp.filter(p => p.StoreType === 1) : null;
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDetail() {
        return (this.customerLevels || []).find((cl) => cl.ID === (this.customer.LevelID || 1));
    }

    get nextLevelDetail() {
        return (this.customerLevels || []).find((cl) => cl.ID === ((this.customerInfo.LevelID || 1) + 1) );
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get textBar() {
        const needPoint = (this.nextLevelDetail ? this.nextLevelDetail.FromMoney : this.customerInfo.TotalTransaction) - this.customerInfo.TotalTransaction;
        return this.nextLevelDetail && needPoint > 0 ? `Cần tích lũy thêm ${formatNumber(needPoint, '0,0')} để lên ${this.nextLevelDetail.VIPName}` : '';
    }

    get colorBar() {
        const percentLevel = this.customerInfo.TotalTransaction / (this.nextLevelDetail ? this.nextLevelDetail.FromMoney : this.customerInfo.TotalTransaction)
        if(percentLevel < 0.3) {
            return '#d9534f';
        } else if (percentLevel < 0.5) {
            return '#dc720f';
        } else if (percentLevel < 0.8) {
            return '#dfe220';
        } else {
            return '#74e220';
        }
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    private async validateForm() {
        const valid = this.$refs['observer'] as any;

        if (!valid) {return false;}
        if (await valid.validate() === true) {return true;}

        if (valid.refs['RePassword'].flags.valid === false || valid.refs['Password'].flags.valid === false) {
            this.selectedTab = this.tab.password;
            return false;
        }

        this.selectedTab = this.tab.customerInfo;
        return false;

    }

    private async created() {
        if (this.$route.query.tab === 'finance') {
            this.selectedTab = this.tab.finance;
        } else if (this.$route.query.tab && (this.tab as any)[this.$route.query.tab as string]) {
            this.selectedTab = (this.tab as any)[this.$route.query.tab as string];
        }
        this.$emit('tabChange', this.selectedTab);

        if (!this.warehouse) {
            await this.getWarehouse();
        }
        if (!this.chinaStore) {
            await this.getChinaStore();
        }
        await this.getProvinces();
        await this.getDistricts();
        await this.getCommunes();
    }

    @Watch('$route.query.tab')
    private onTabQueryChange(val: string) {
        if (val === 'finance') {
            this.selectedTab = this.tab.finance;
        } else if (val && (this.tab as any)[val]) {
            this.selectedTab = (this.tab as any)[val];
        }
        this.$emit('tabChange', this.selectedTab);
    }

    private async getProvinces() {
        const result = await commonService.getProvince();
        if (result && result.status === 200) {
            this.provinces = result.data.data;
        }
    }

    private async getDistricts() {
        if (this.customer.ProvinceID) {
            const result = await commonService.getDistrict(this.customer.ProvinceID);
            if (result && result.status === 200) {
                this.districts = result.data.data;
            } else {
                this.districts = []
            }
        } else {
            this.districts = []
        }
    }

    private async getCommunes() {
        if (this.customer.DistrictID) {
            const result = await commonService.getCommune(this.customer.DistrictID);
            if (result && result.status === 200) {
                this.communes = result.data.data;
            } else {
                this.communes = []
            }
        } else {
            this.communes = []
        }
    }

    private onProvinceChange(event) {
        this.customer.DistrictID = '';
        this.getDistricts();
    }

    private onDistrictChange(event) {
        this.customer.CommuneID = '';
        this.getCommunes();
    }
}
